module.exports = __webpack_public_path__ + "img/packaged.7f54244e.png";